export const initialState = Object.freeze({
  loader: false,
});

export type AppState = typeof initialState;
